import { apiGet, apiPatch } from './client';
import type {
  TradePlaceBloomberg,
  TradePlaceBloombergBatchRequest,
} from '../types/TradePlaceBloomberg';

export function getTradePlacesBloomberg(): Promise<TradePlaceBloomberg[]> {
  return apiGet<TradePlaceBloomberg[]>('/api/trade-places-bloomberg');
}

export function saveBatchTradePlacesBloomberg(
  added: TradePlaceBloomberg[],
  modified: TradePlaceBloomberg[],
  deletedIds: string[],
): Promise<TradePlaceBloomberg[]> {
  return apiPatch<TradePlaceBloombergBatchRequest, TradePlaceBloomberg[]>(
    '/api/trade-places-bloomberg/batch',
    { added, modified, deleted: deletedIds },
  );
}
